<script lang="ts">
  import { completeSharedAccountAccess } from "../../lib/sharedAccount";
  import { alertStore } from "../../stores/alertStore";
  import { ButtonComponent, InputField } from "ui";

  export let data: {
    accountId?: number;
    name?: string;
  } = {};

  let password = "";
  let isLoading = false;

  const submit = async (): Promise<void> => {
    if (!password.trim()) {
      return;
    }

    isLoading = true;

    try {
      await completeSharedAccountAccess(password);
    } catch (error) {
      alertStore.show((error as Error).message, "error");
      isLoading = false;
      return;
    }

    isLoading = false;
  };
</script>

<form class="p-6 flex flex-col gap-4" on:submit|preventDefault={submit}>
  <div class="flex flex-col gap-1">
    <div class="text-lg font-semibold">Personal password required</div>
    <div class="text-sm text-slate-600 dark:text-slate-300">
      Account {data.accountId}
      {#if data.name}
        ({data.name})
      {/if}
      is shared by multiple people. Enter your personal password to continue so activity can be attributed correctly.
    </div>
  </div>

  <InputField
    type="password"
    label="Personal password"
    placeholder="Enter your personal password"
    bind:value={password}
  />

  <div class="flex justify-end">
    <ButtonComponent type="submit" {isLoading} disabled={!password.trim()}>
      Continue
    </ButtonComponent>
  </div>
</form>
